<template>

  <card titulo="Referências">

    <card-table class="table-borderless mb-1">

      <thead>
        <tr>
          <th width="180px">Origem</th>
          <th class="text-center" width="90px">Ato</th>
          <th class="text-center">Tipo</th>
          <th>Descrição</th>
          <th  width="15px;" v-if="!visualizar"></th>
          <th  width="15px;" v-if="!visualizar">
            <i class="fa fa-plus-square pointer float-right mr-2" @click="form()"></i>
          </th>
        </tr>
      </thead>

      <tbody>

        <tr v-for="(registro, i) in ficha.referencias" :key="i">
          <td class="pr-2 icon">
            <!-- A unidade que a análise leu do teor é TRANSMISSAO sem ficha de destino vinculada, e
                 chega com `referenciaDetalhes` nulo. Nomear essa ficha lançava TypeError no render,
                 e o Vue 2 descartava o card inteiro em silêncio. Sem ficha não há o que abrir: a
                 célula mostra a matrícula de destino digitada, quando há, e não oferece o clique. -->
            <a v-if="registro.referenciaDetalhes" @click.prevent="detalhesFichaIndicadorReal(registro.referenciaId)">{{nomearFicha(registro.referenciaDetalhes)}} </a>
            <template v-else>{{origemSemFicha(registro)}}</template>
          </td>
          <td class="text-center pr-2">{{registro.ato}}</td>
          <td class="text-center pr-2">{{formatarTipoReferencia(registro.tipo)}}</td>
          <td class="pr-2">{{registro.descricao}}</td>

          <td style="padding-left: 0px;" class="text-right pr-2" v-if="!visualizar">
            <a class="icon" title="Editar" @click.prevent="form(registro, i)">
              <i class="fa fa-edit"></i>
            </a>
          </td>

          <td style="padding-left: 0px;" class="text-right pr-2" v-if="!visualizar">
            <a class="icon" title="Excluir" @click.prevent="remove(i)">
              <i class="far fa-trash-alt"></i>
            </a>
          </td>
        </tr>
      </tbody>

    </card-table>
      <div v-if="!ficha.referencias || !ficha.referencias.length">
        <div class="p-3 text-truncate alert alert-warning">
          Nenhuma referência informada
        </div>
      </div>
  </card>

</template>

<script>

  import FrontBusiness from "@/business/FrontBusiness";
  import IndicadorRealBusiness from '@/business/indicadores/IndicadorRealBusiness';
  import Utils from "@/commons/Utils.js";
  import DetalhesIndicadorReal from "@/components/IndicadorReal/Detalhes/DetalhesIndicadorReal.vue";
  import ReferenciaImovelForm from "@/components/IndicadorReal/ReferenciaImovelForm.vue";
  import Card from "@/components/Layout/components/Card.vue";
  import CardTable from "@/components/Layout/components/CardTable.vue";

  export default {

    name: "ReferenciaImovelLista",
    components: {Card, CardTable},
    props: {
      ficha: Object,
      visualizar: {type: Boolean, default: false},
      matriculaMae: Object,
      /**
       * A referência que deve ser aberta para edição assim que o card montar, ou `null`.
       *
       * Chega da aba "Unidades" da ficha, que é somente leitura e por isso manda o conferente para
       * cá quando ele clica no lápis de uma unidade. Vem como `{ato, designacao, descricao}` em vez
       * de um índice porque as duas telas carregam a ficha por consultas próprias: índice casaria
       * a linha errada no dia em que a ordem mudasse, e a linha errada aberta para edição é pior do
       * que nenhuma.
       */
      abrir: {type: Object, default: null}
    },

    data() {
      return {
      }
    },

    mounted() {
      if(!this.ficha.referencias){
        this.ficha.referencias = [];
      }
      this.abrirSolicitada();
    },

    methods: {

      /**
       * Abre o formulário da referência que a aba "Unidades" pediu.
       *
       * Não achando a linha, o card fica aberto e nada acontece: a lista inteira está na tela e o
       * conferente escolhe a mão. Abrir "a primeira parecida" seria oferecer para edição uma
       * unidade que ele não pediu.
       */
      abrirSolicitada() {
        if (!this.abrir || this.visualizar) return;
        const indice = this.indiceDaReferencia(this.abrir);
        if (indice < 0) return;
        this.$nextTick(() => this.form(this.ficha.referencias[indice], indice));
      },

      indiceDaReferencia(alvo) {
        const registros = this.ficha.referencias || [];
        const designacao = this.chaveDeTexto(alvo.designacao);
        const descricao = this.chaveDeTexto(alvo.descricao);
        const ato = alvo.ato == null ? null : Number(alvo.ato);
        return registros.findIndex(r => {
          // Os DOIS tipos de unidade, e não só a transmissão: o lápis da aba "Unidades" também sai
          // da linha de estoque, e procurá-la por um tipo que ela não tem abriria o card sem abrir
          // a linha — o conferente clicaria e nada aconteceria.
          if (!r || !IndicadorRealBusiness.eReferenciaDeUnidade(r.tipo)) return false;
          if (ato !== null && r.ato != null && Number(r.ato) !== ato) return false;
          const casaDesignacao = designacao && this.chaveDeTexto(r.designacao) === designacao;
          const casaDescricao = descricao && this.chaveDeTexto(r.descricao) === descricao;
          return !!(casaDesignacao || casaDescricao);
        });
      },

      /** Texto comparável: sem acento, sem caixa e sem espaço sobrando. */
      chaveDeTexto(valor) {
        if (valor === null || valor === undefined) return null;
        const texto = String(valor)
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .toLowerCase().replace(/\s+/g, ' ').trim();
        return texto || null;
      },

      async form(registro, index) {
        let response = await FrontBusiness.openModal(ReferenciaImovelForm, {registro: Utils.clone(registro), matriculaMae: this.matriculaMae});
        if (response) {
          const registros = this.ficha.referencias || [];
          if (index === null || index === undefined) {
            registros.push(response);
          } else {
            registros[index] = response;
          }
          this.$set(this.ficha, 'referencias', registros);
          this.$forceUpdate();
        }
        console.debug('response', this.ficha.referencias, response)
      },

      remove(index) {
        const registros = this.ficha.referencias || [];
        registros.splice(index, 1);
        this.$set(this.ficha, 'referencias', registros);
      },

      async detalhesFichaIndicadorReal(id){
        await FrontBusiness.openModal(DetalhesIndicadorReal, {id});
      },

      nomearFicha(ficha){
        return FrontBusiness.nomearFicha(ficha);
      },

      origemSemFicha(registro) {
        return FrontBusiness.nomearOrigemReferencia(registro);
      },

      formatarTipoReferencia(tipo){
        return FrontBusiness.getLabel(tipo, IndicadorRealBusiness.getTiposReferencia());
      },

    }

  }
</script>
